'use strict';
import globals from './lib/globals';
import Logger from "./utilities/Logger";
import Evts from "./utilities/Evts";

// Bootstrap global functionality
globals();

const NAME = 'POLICY-TERMS';
Logger.log(NAME);

//  View Controller
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init --- Initialize application.
 */
function init() {
	Logger.log(`${NAME} > init`);
}
